/**
 * Product Accordion
 * Desktop (768px+): Content floats upward as overlay
 * Mobile (<768px): Standard collapsible, content opens below and pushes down
 *
 * Reviews + Loox: widget hydrates via Loox core script.
 * Keep Reviews collapsed with height only (not visibility:hidden) so Loox can init,
 * then remeasure the overlay when the widget finishes loading.
 */

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  function initAccordion() {
    var accordionItems = document.querySelectorAll('.accordion-item');
    if (!accordionItems.length) return;

    accordionItems.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        toggleAccordion(item);
      });

      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(item);
        }
      });
    });

    function toggleAccordion(item) {
      if (item.classList.contains('active')) {
        closeAccordion(item);
      } else {
        closeAllAccordions();
        openAccordion(item);
      }
    }

    function setOverlayHeight(item) {
      var overlay = item.querySelector('.accordion-overlay');
      var overlayContent = item.querySelector('.accordion-overlay-content');
      if (!overlay || !overlayContent) return;

      var isReviews = item.getAttribute('data-accordion') === 'review-returns';
      var measured = overlayContent.scrollHeight + 40;
      var minHeight = isReviews ? 520 : 0;
      overlay.style.maxHeight = Math.max(measured, minHeight) + 'px';
    }

    function reinitLoox() {
      try {
        if (window.loox) {
          if (typeof window.loox.init === 'function') window.loox.init();
          if (typeof window.loox.reload === 'function') window.loox.reload();
          if (typeof window.loox.refresh === 'function') window.loox.refresh();
        }
        if (window.LOOX && typeof window.LOOX.init === 'function') {
          window.LOOX.init();
        }
        window.dispatchEvent(new Event('resize'));
      } catch (err) {
        // Ignore until Loox scripts finish loading
      }
    }

    function refreshReviews(item) {
      if (item.getAttribute('data-accordion') !== 'review-returns') return;

      reinitLoox();

      [200, 600, 1200, 2500, 4000].forEach(function (delay) {
        setTimeout(function () {
          if (!item.classList.contains('active')) return;
          reinitLoox();
          setOverlayHeight(item);
        }, delay);
      });

      var reviewRoot = item.querySelector('#review-content, #looxReviews');
      if (!reviewRoot || typeof MutationObserver === 'undefined') return;

      if (item._looxObserver) item._looxObserver.disconnect();

      item._looxObserver = new MutationObserver(function () {
        if (item.classList.contains('active')) setOverlayHeight(item);
      });
      item._looxObserver.observe(reviewRoot, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }

    function openAccordion(item) {
      var trigger = item.querySelector('.accordion-trigger');
      var overlay = item.querySelector('.accordion-overlay');
      var overlayContent = item.querySelector('.accordion-overlay-content');
      if (!overlay || !overlayContent) return;

      item.classList.add('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');

      setOverlayHeight(item);
      refreshReviews(item);
    }

    function closeAccordion(item) {
      var trigger = item.querySelector('.accordion-trigger');
      var overlay = item.querySelector('.accordion-overlay');
      if (!overlay) return;

      item.classList.remove('active');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      overlay.style.maxHeight = '0';

      if (item._looxObserver) {
        item._looxObserver.disconnect();
        item._looxObserver = null;
      }
    }

    function closeAllAccordions() {
      accordionItems.forEach(function (item) {
        if (item.classList.contains('active')) closeAccordion(item);
      });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        accordionItems.forEach(function (item) {
          if (item.classList.contains('active')) setOverlayHeight(item);
        });
      }, 250);
    });

    // Warm Loox once scripts are available (widget lives in Reviews panel)
    var warmTries = 0;
    var warmTimer = setInterval(function () {
      warmTries += 1;
      if (window.loox || window.LOOX) {
        reinitLoox();
        clearInterval(warmTimer);
      } else if (warmTries >= 40) {
        clearInterval(warmTimer);
      }
    }, 250);
  }
})();
